import React, { InputHTMLAttributes } from "react";

import styles from "./ValidatableCheckbox.module.css";

export type ValidatableCheckboxUIProps = InputHTMLAttributes<HTMLInputElement>;

export const ValidatableCheckboxUI = React.forwardRef<
  HTMLInputElement,
  ValidatableCheckboxUIProps
>(({ className, children, id, name, ...rest }, ref) => {
  return (
    <div className={`flex items-center ${className}`}>
      <input
        ref={ref}
        className={`appearance-none bg-white border border-dark-gray h-4 w-4 rounded mr-2.5 ${styles.check}`}
        type="checkbox"
        id={id}
        name={name}
        {...rest}
      />
      <label htmlFor={id}>{children}</label>
    </div>
  );
});
